/*  eslint-disable camelcase */
import { Cart } from '../../util/typings';

interface IFReduxCart {
  cartActive: boolean;
  minicartOpen: boolean,
  current: Cart;
}

const cart: Cart = {
  token: '',
  note: '',
  attributes: {},
  total_price: 0, 
  total_weight: 0,
  total_discount: 0,
  original_total_price: 0,
  item_count: 0,
  requires_shipping: true,
  currency: '',
  items: [],
}

const cartInitialState: IFReduxCart = {
  cartActive: false,
  minicartOpen: false,
  current: cart,
}


export default cartInitialState